import { c as _c } from "react/compiler-runtime";
import { MarkdownText } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { templatedChildren } from '../../../components/templated-text';
import type { CustomQuestionsFormData } from '../../../types';
type TextBlockPreviewProps = {
  questionIndex: number;
};
const TextBlockPreview = t0 => {
  const $ = _c(7);
  const {
    questionIndex
  } = t0;
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.content`;
  let t2;
  if ($[0] !== control || $[1] !== t1) {
    t2 = {
      control,
      name: t1
    };
    $[0] = control;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const content = useWatch(t2);
  if (!content) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="text-body-2 text-tertiary italic">-</div>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      p: _temp
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== content) {
    t4 = <div className="text-body-2 text-primary wrap-break-word overflow-hidden"><MarkdownText components={t3}>{content}</MarkdownText></div>;
    $[5] = content;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default TextBlockPreview;
function _temp(t0) {
  const {
    children
  } = t0;
  return <p>{templatedChildren(children)}</p>;
}